module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "04reports.ef941056.png" + "?" + Date.now();